module.exports = "<app-page-container>\n  <app-button routerLink=\"music\">Welcome</app-button>\n</app-page-container>\n"